<template>
    <div class="w3-modal">
        <div class="w3-modal-content flow-card no-top">
            <header class="w3-container">
                <h2 class="w3-border-bottom">
                    <slot name="header"></slot>
                </h2>
                <span @click.prevent="close" class="w3-padding cursor-pointer w3-display-topright w3-xlarge">&times;</span>
            </header>
            <div class="w3-container w3-margin-bottom">
                <slot name="body0"></slot>

                <div class="w3-center w3-margin-bottom">
                    <slot name="body1"></slot>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../main";

    export default {
        name: "Modal",
        data() {
            return {
                showModal: true
            }
        },
        methods: {
            close() {
                this.showModal = false;
                EventBus.$emit("modalClosed");
            }
        }
    }
</script>

<style>
    .w3-modal {
        display: block;
    }
    .w3-modal-content {
        border-radius: 5px;
    }
</style>